import { NavegacionProductos } from '../../components';

const FrijolesEnterosNegros = () => {
    return <NavegacionProductos />;
};

export default FrijolesEnterosNegros;
